import { withKeys as _withKeys, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c6d4dea"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(_ctx.$style.searchBar)
  }, [
    _createElementVNode("input", {
      type: "text",
      placeholder: "Search or Add...",
      value: $props.searchText,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:searchText', $event.target.value))),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($setup.submit($props.searchText)), ["enter"])),
      onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('update:searchText', '')), ["esc"]))
    }, null, 40, _hoisted_1),
    ($props.searchText !== '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.controls)
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.$style.cancel),
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:searchText', '')))
          }, [
            _createVNode($setup["Cancel"])
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.$style.add),
            type: "button",
            disabled: !$props.matchFound,
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.submit($props.searchText)))
          }, [
            _createVNode($setup["Add"])
          ], 10, _hoisted_2)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}